// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header_B4uWq,.root_y\\+ekh{width:100%}.header_B4uWq{padding:8px 15px;background:#fff;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.header_B4uWq .headerContent_Z43Gw{display:flex;justify-content:space-between;align-items:center}.header_B4uWq .headerContent_Z43Gw,.header_B4uWq .headerContent_Z43Gw h2{font-weight:600;font-size:16px;line-height:24px}.header_B4uWq.dark_olFDq{background-color:#f6f7f7}.header_B4uWq.notCollapsible_H2EHx{cursor:inherit}.icon_ah9Nr{transition:transform .15s ease-in-out}.icon_ah9Nr.open_WxuRz{transform:scaleY(-1)}.body_v2rxJ{padding-bottom:15px;font-size:14px;font-weight:400;line-height:20px}.slot_7HfpF:not(.contentOnly_jZ8Bw){padding:20px 15px 5px;background:#f6f7f7}.root_y\\+ekh.productDetails_UoG-i .header_B4uWq .headerContent_Z43Gw,.root_y\\+ekh.productDetails_UoG-i .slot_7HfpF .slotContent_8-gqs{margin:0 auto;max-width:900px}", ""]);
// Exports
exports.locals = {
	"header": "header_B4uWq",
	"root": "root_y+ekh",
	"headerContent": "headerContent_Z43Gw",
	"dark": "dark_olFDq",
	"notCollapsible": "notCollapsible_H2EHx",
	"icon": "icon_ah9Nr",
	"open": "open_WxuRz",
	"body": "body_v2rxJ",
	"slot": "slot_7HfpF",
	"contentOnly": "contentOnly_jZ8Bw",
	"productDetails": "productDetails_UoG-i",
	"slotContent": "slotContent_8-gqs"
};
module.exports = exports;
